<template>
    <div>
        <label :for="id">{{label}}</label>
        <small class="text-muted" style="display: block;">All mobile devices have a unique identity 
      (IMEI number).  This can be displayed on-screen by entering *#06# or through Settings / 
      About.  If your device has more than one IMEI please provide the primary IMEI sometimes 
      called IMEI1.  The IMEI should be 15 digits long, comprising only numbers and entered with 
      no spaces.</small>
        <input type="text" :id="id" :fieldlabel="validationFieldLabel" v-model="imei" v-taurus-validator="'imei_format|required'" maxlength="15">
        <div :name="id" :invalidfeedback="validationInvalidFeedback"></div>
    </div>
</template>
<script>
    export default {
        props: {
            value: { required: true },
            id: { required: true },
            label: { 
                type: String,
                required: false,
                default: 'IMEI' 
            },
            validationFieldLabel: {
                type: String,
                required:false,
                default: "IMEI"
            },
            validationInvalidFeedback: {
                type: String,
                required:false,
                default: "Please enter the correct IMEI"
            }
        },
        data: () => {
            return {
                imei: null
            }
        },
        mounted() {
            this.imei = this.value
        },
        watch: {
            // value(newVal, oldVal) {
            //     if (newVal != oldVal) {
            //         this.imei = newVal
            //     }
            // },
            imei(newVal,oldVal) {
                if (newVal != oldVal) {
                    this.$emit('input', this.imei)
                }
            }
        }
    }
</script>